module.exports = __webpack_public_path__ + "img/rowPath.b98cf190.svg";